import { createSlice } from "@reduxjs/toolkit";

const initiateCart = () => {
  let items = [];

  let savedCart = localStorage.getItem("agentCart");
  if (savedCart) {
    items = JSON.parse(savedCart);
  }

  return items;
};

let initialState = {
  cart: initiateCart(),
  quotes: [],
  quote: null,
  quoteToAddPackageTo: null,
  quoteToBeShared: null,
  quoteSearch: "",
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload;
      localStorage.setItem("agentCart", JSON.stringify(action.payload));
    },
    setQuote: (state, action) => {
      state.quote = action.payload;
    },
    setQuoteToAddPackageTo: (state, action) => {
      state.quoteToAddPackageTo = action.payload;
    },
    setQuotes: (state, action) => {
      state.quotes = action.payload;
    },
    setQuoteToBeShared: (state, action) => {
      state.quoteToBeShared = action.payload;
    },
    setQuoteSearch: (state, action) => {
      state.quoteSearch = action.payload;
    },
  },
});

export const {
  setCart,
  setQuoteToBeShared,
  setQuotes,
  setQuoteSearch,
  setQuote,
  setQuoteToAddPackageTo,
} = cartSlice.actions;

export default cartSlice.reducer;
